import { FormikErrors, FormikHelpers, useFormik } from 'formik';
import { Container, ContainerMoveState, ContainerFormSchema, InitialValues } from './types';

export function useContainerManagement(): ContainerMoveState {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const form = useFormik<Container>({
    initialValues: InitialValues,
    validationSchema: ContainerFormSchema,
    validateOnChange: false,
    validateOnBlur: true,

    validate: (values) => {
      const errors: FormikErrors<Container> = {};
      return Promise.resolve(errors);
    },
    onSubmit: async (values: Container, helpers: FormikHelpers<Container>) => {
      // eslint-disable-next-line no-alert
    },
  });

  return {
    form,
  };
}
